import React, { useState } from 'react';
import { Dropdown } from '../../../../components/Dropdown';
import { IconSpan } from '../../../../components/IconSpan';
import { ConfirmationModal } from '../../../../components/ConfirmationModal';
import { AlertMessage } from '../../../../components/AlertMessage';
import { JobRequisitionReasonService } from '../../../../services/v1/applicant_tracking/JobRequisitionReasonService';

interface PropTypes {
  id: number;
  editJobRequisitionReasonUrl: string;
}

function buildMenuAction(
  action: () => void,
  label: string,
  iconName: string,
  enabled: boolean,
) {
  if (!enabled) return null;

  return {
    action: action,
    buttonChild: (
      <IconSpan
        spanText={label}
        icon={{ name: iconName, className: 'fs-4' }}
        className={'text-blue'}
      />
    ),
  };
}

function editButton(editJobRequisitionReasonUrl: string) {
  return buildMenuAction(
    () => (window.location.href = editJobRequisitionReasonUrl),
    'Edit',
    'bi-pencil',
    true,
  );
}

function deleteButton(setDeleteModal: (flag: boolean) => void) {
  return buildMenuAction(
    () => setDeleteModal(true),
    'Delete',
    'bi-trash',
    true,
  );
}

function DeleteModal(props: {
  isOpen: boolean;
  onConfirm: () => void;
  setIsOpen: (open: boolean) => void;
}) {
  return (
    <ConfirmationModal
      title='Delete Requisition Reason'
      body={
        <>
          <p>Are you sure you want to delete this requisition reason?</p>
          <AlertMessage
            hasOverlay={false}
            icon={{ name: 'bi-info-circle' }}
            className='mt-3h fs-5 bg-light-warning'
            text={
              <span>
                Deleting this reason makes it unavailable for new requisitions
                but keeps it in existing ones. This action cannot be undone.
              </span>
            }
          />
        </>
      }
      isOpen={props.isOpen}
      onConfirm={props.onConfirm}
      onCancel={() => props.setIsOpen(false)}
      size={'md'}
      confirmText={'Delete'}
      disableAfterConfirm={true}
    />
  );
}

export default function RowActionsDropdown(props: PropTypes) {
  const [deleteModal, setDeleteModal] = useState(false);

  const handleConfirm = async () => {
    await JobRequisitionReasonService.delete(props.id).then(() =>
      window.location.reload(),
    );
  };

  return (
    <>
      <DeleteModal
        isOpen={deleteModal}
        onConfirm={handleConfirm}
        setIsOpen={setDeleteModal}
      />
      <Dropdown
        buttonIcon={{
          name: 'bi-three-dots',
          className: 'fs-4 text-info',
        }}
        menuPlacementClass={'dropdown-menu-end'}
        menuActions={[
          editButton(props.editJobRequisitionReasonUrl),
          deleteButton(setDeleteModal),
        ]}
      />
    </>
  );
}
